import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Component,
  effect,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvButtonComponent } from '@devinco/ui/dds';
import { TranslateModule } from '@ngx-translate/core';
import { HistoricalPositionDialogComponent } from '../historical-position-dialog/historical-position-dialog.component';
import { HistoricalPositionService } from '@pages/fleet/services/historical-position-service';

@Component({
  selector: 'app-historical-position-toggle',
  imports: [DvButtonComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './historical-position-toggle.component.html',
})
export class HistoricalPositionToggleComponent {
  historicalPositionService = inject(HistoricalPositionService);
  private overlay = inject(Overlay);

  readonly isHistoricalPositionActive = signal(false);

  constructor() {
    effect(() => {
      const serviceSelected =
        !!this.historicalPositionService.selectedHistoricalDateTime();

      if (this.isHistoricalPositionActive() !== serviceSelected) {
        this.isHistoricalPositionActive.set(serviceSelected);
      }
    });
  }

  toggleHistoricalPosition(): void {
    if (!this.isHistoricalPositionActive()) {
      const overlayConfig = new OverlayConfig({
        positionStrategy: this.overlay
          .position()
          .global()
          .centerHorizontally()
          .centerVertically(),
        hasBackdrop: true,
      });
      const overlayRef = this.overlay.create(overlayConfig);
      const dialogPortal = new ComponentPortal(
        HistoricalPositionDialogComponent
      );

      const dialog = overlayRef.attach(dialogPortal);
      dialog.instance.cancelClicked.subscribe(() => {
        this.historicalPositionService.selectedHistoricalDateTime.update(
          () => undefined
        );
        overlayRef.detach();
      });
      dialog.instance.confirmClicked.subscribe(selectedDateTime => {
        this.historicalPositionService.selectedHistoricalDateTime.update(
          () => selectedDateTime
        );
        overlayRef.detach();
      });
      return;
    }

    this.historicalPositionService.selectedHistoricalDateTime.update(
      () => undefined
    );
  }
}
